// pages/PaymentPage.jsx
import React, { useEffect, useState } from "react";



import { useLocation, useNavigate } from "react-router-dom";
import InputField from "./InputField";
import axios from "axios"
import ReactPixel from "react-facebook-pixel"  



 
export default function PaymentPage() {
  const [summary, setSummary] = useState({
    date: "",
    package: "",
    tickets: [],
    total: 0,
  });





  

const navigate = useNavigate()

  useEffect(() => {
    const stored = localStorage.getItem("bookingSummary");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (parsed?.date && parsed?.tickets && parsed?.package) {
          setSummary(parsed);
        }
      } catch (err) {
        console.error("Invalid JSON in localStorage.bookingSummary", err);
      }
    }
  }, []);

  return (
    <div className="min-h-screen flex justify-center items-start bg-cover bg-center py-16 px-4" style={{ backgroundImage: `url('/bg.png')` }}>
      <div className="bg-white rounded-lg max-w-3xl w-full p-8 shadow-xl">
        {/* Steps */}
        <div className="flex justify-center items-center mb-10 space-x-2 text-sm md:text-base font-semibold">
          {["1. Ticket", "2. Summary", "3. Payment", "4. Done"].map((step, i) => (
            <div key={i} className="flex items-center space-x-1">
              <span className={`px-2 pb-1 ${i === 2 ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-400"}`}>{step}</span>
              {i < 3 && <span className="text-gray-300">&#8250;</span>}
            </div>
          ))}
        </div>

        <h2 className="text-lg font-bold text-gray-800 mb-4">Order Details</h2>
        <div className="border rounded overflow-hidden mb-8">
          <div className="grid grid-cols-2 bg-gray-50 border-b p-4 font-bold text-gray-700">
            <div>Ticket Summary</div>
            <div>
              {summary.date && new Date(summary.date).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
                weekday: "long"
              })}, {summary.package}
            </div>
          </div>
          <div className="p-4 space-y-2 bg-white">
            {summary.tickets.map((ticket, i) => (
              <div key={i} className="text-gray-700">
                {ticket.label} x {ticket.qty} = RM {(ticket.qty * ticket.price).toFixed(2)}
              </div>
            ))}
          </div>
          <div className="grid grid-cols-2 border-t bg-gray-50 p-4 font-bold text-gray-800">
            <div>Total Payment</div>
            <div>RM {summary.total.toFixed(2)}</div>
          </div>
        </div>

        <h2 className="text-lg font-bold text-gray-800 mb-4">Contact Details</h2>
 

        <div className="grid md:grid-cols-2 gap-4 mb-4">
          <input type="text" placeholder="*First Name" className="border rounded px-4 py-2 w-full" />
          <input type="text" placeholder="*Last Name" className="border rounded px-4 py-2 w-full" />
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-4">
          <div className="flex gap-2">
            <select className="border rounded px-4 py-2">
              <option>+60</option>
              <option>+65</option>
              <option>+971</option>
            </select>
            <input type="text" placeholder="*Contact Number" className="border rounded px-4 py-2 flex-1" />
          </div>
        </div>

        <div className="grid md:grid-cols-1 gap-4 mb-4">
          <input type="email" placeholder="*Email" className="border rounded px-4 py-2 w-full" />
          <input type="email" placeholder="*Confirm Email" className="border rounded px-4 py-2 w-full" />
        </div>

        <p className="text-sm text-gray-700 my-4">
          If you experience difficulties or are unsure if your transaction is successful, please DO NOT repeat your order or perform another transaction.
        </p>

        <p className="text-sm text-gray-700 mb-4">
          Kindly contact us at <strong>info.lshsm@limseonghai.com</strong> / <strong>+603-4021 8899 (care centre)</strong>.
        </p>

        <div className="flex items-center gap-2 mb-8">
          <input type="checkbox" className="w-5 h-5" id="terms" />
          <label htmlFor="terms" className="text-sm text-gray-700">
            I have read and agree to the <a href="#" className="text-blue-600 underline">Terms and Conditions</a>, <a href="#" className="text-blue-600 underline">Privacy Policy</a> &amp; <a href="#" className="text-blue-600 underline">Refund Policy</a>.
          </label>
        </div>

        <div className="flex justify-end gap-4">
          <button  onClick={()=>navigate('/summary')} className="px-8 py-3 bg-gray-300 hover:bg-gray-400 text-xs text-black rounded font-bold transition">Back</button>
        <button

        
  onClick={() => {
    navigate('/checkout')
    // Здесь ты можешь добавить валидацию формы, если надо
    const finalSummary = {
      ...summary,
      paidAt: new Date().toISOString(), // можно добавить дату оплаты
    };
    localStorage.setItem("bookingSummary", JSON.stringify(finalSummary));
   }}
  className="px-8 py-3 bg-[#3e3e52] hover:bg-[#0BBAE3] text-cyan-400 text-xs hover:text-black rounded font-bold transition"
>
  Pay Now
</button></div>
      </div>
    </div>
  );
}
